module.exports = __webpack_public_path__ + "img/22.0b2c5a51.jpg";